import { Component, Input, OnInit } from '@angular/core';
import { HvlBaseModel } from '@hvlng/framework-bff/core/src/model/hvl-base-model';
import { UiTranslateLoaderService } from 'ui-shared';
import { ApprovableDataService } from '../../service/approvable-data.service';
import { HrMasterDataRecordHistoryService } from '../../service/hr-master-data-record-history.service';

@Component({
    selector: 'hr-history-split-button',
    templateUrl: './hr-history-split-button.component.html',
})
export class HrHistorySplitButtonComponent implements OnInit {

    @Input() selectionItem : HvlBaseModel;
    @Input() businessKey: string = "";
    @Input() processDefinitionKey: string = "";
    @Input() showRecordHistory: boolean = true;
    @Input() showBpmnHistory: boolean = false;
    @Input() pageCode: string;
    items = [];
    constructor(
        private uiTranslateLoaderService: UiTranslateLoaderService,
        private approvableDataService: ApprovableDataService,
        private hrMasterDataRecordHistoryService: HrMasterDataRecordHistoryService,
    ) {}

    ngOnInit(): void {
        if (this.showBpmnHistory) {
            this.items.push({
                    label: this.uiTranslateLoaderService.instant('hrHistorySplitButton.bpmnHistory'),
                    command: () => {
                        this.approvableDataService.openBPMNHistory(this.businessKey, this.processDefinitionKey);
                    },
                },
            );
        }

        if (this.showRecordHistory) {
            this.items.push({
                    label: this.uiTranslateLoaderService.instant('hrMasterDataRecordHistory.recordHistory'),
                    command: () => {
                        this.hrMasterDataRecordHistoryService.openRecordHistory(this.selectionItem);
                    },
                },
            );
        }
    }
}
